import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'drdp-portfolio-messages',
    templateUrl: './portfolio-messages.component.html',
    styleUrls: ['./portfolio-messages.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PortfolioMessagesComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {}
}
